import { ROUTE_PATH_PROTECTION } from '../../../constants';
import { ResourceCentrePageTranslations } from '../../types';
// import { translations as generalInfo } from './generalinfo';
// import { translations as infoSecurity } from './infosec';
import { translations as lostItemRecovery } from './recovery';
// import { translations as travelSafety } from './travelsafety';

export const translations: ResourceCentrePageTranslations = {
  docTitle: 'Resource Centre',
  pageTitle: 'Resource Centre',
  backToParentPage: {
    to: ROUTE_PATH_PROTECTION,
    exact: true,
    children: 'Back to Lost Wallet Protection'
  },
  categories: {
    lostItemRecovery
    // infoSecurity,
    // travelSafety,
    // generalInfo
  }
};
